"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const userLogin_component_1 = require("./userLogin/userLogin.component");
const userLevelCheck_directive_1 = require("./userLevelCheck/userLevelCheck.directive");
const resource_service_1 = require("./resources/resource.service");
const commonUi_module_1 = require("../../commonUi/src/commonUi.module");
const translate_module_1 = require("../../translate/src/translate.module");
let UserAuthenticationModule = class UserAuthenticationModule {
    //Resource manager adds the translations to the translationservice
    constructor(_resourceManager) {
        this._resourceManager = _resourceManager;
    }
};
UserAuthenticationModule = __decorate([
    core_1.NgModule({
        imports: [
            commonUi_module_1.CommonUiModule,
            forms_1.FormsModule,
            translate_module_1.TranslateModule
        ],
        exports: [
            userLogin_component_1.UserLoginComponent,
            userLevelCheck_directive_1.UserLevelCheckDirective
        ],
        declarations: [
            userLogin_component_1.UserLoginComponent,
            userLevelCheck_directive_1.UserLevelCheckDirective
        ],
        providers: [
            resource_service_1.UserAuthenticationResourceManager, { provide: 'Window', useValue: window }
        ],
        bootstrap: []
    }),
    __metadata("design:paramtypes", [resource_service_1.UserAuthenticationResourceManager])
], UserAuthenticationModule);
exports.UserAuthenticationModule = UserAuthenticationModule;
